import { useState } from 'react';
import { mastheadNav } from '@/mocks/home';

export default function Masthead() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 w-full">
      <div className="w-full bg-primary-700 text-background-50">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-2 text-[11px] tracking-[0.2em] md:px-8 md:text-xs">
          <span className="flex items-center gap-2">
            <i className="ri-bookmark-3-line text-accent-300" />
            <span className="whitespace-nowrap">2026 安全验证特辑 · 第 09 期</span>
          </span>
          <span className="hidden items-center gap-2 text-primary-100 md:flex">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
            官方核验结果每日更新
          </span>
        </div>
      </div>

      <div className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur-md">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-6 px-4 py-3 md:px-8 md:py-4">
          <a href="#top" className="group flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50 md:h-11 md:w-11">
              <i className="ri-mic-2-line text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">
                黑料地址
              </span>
              <span className="mt-1 text-[10px] tracking-[0.28em] text-foreground-500">
                安全导航 · 真假辨别
              </span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex">
            {mastheadNav.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="cursor-pointer whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#verify"
              className="hidden cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:flex"
            >
              <i className="ri-shield-check-line" />
              进入安全入口
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label="打开导航"
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden"
            >
              <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 md:hidden">
            <nav className="mx-auto flex max-w-[1400px] flex-col px-4 py-2">
              {mastheadNav.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="cursor-pointer border-b border-background-100 px-1 py-3 text-sm font-medium text-foreground-700 last:border-0"
                >
                  {item.label}
                </a>
              ))}
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="cursor-pointer py-3 text-sm font-semibold text-primary-700"
              >
                订阅安全提醒
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}